import { compose, pure, withHandlers } from "recompose";

import BankAccountForm from "./BankAccountForm";
import Queries from "../../queries/queries2";
import React from "react";
import Spinner from "../../elements/Spinner/Spinner";
import { graphql } from "react-apollo";
import { withRouter } from "react-router-dom";

const handlers = withHandlers({
  onSave: ({
    id,
    updateBankAccountMutation,
    location,
    history,
    companyId
  }) => params => {
    //console.log("params, id", params, id);
    updateBankAccountMutation({
      variables: params,
      refetchQueries: [
        { query: Queries.GET_ALL_BANK_ACCOUNTS, variables: { companyId } },
        { query: Queries.GET_BANK_ACCOUNT, variables: { id } }
      ]
    });
    history.push("/payments");
  },

  onUnsynchronize: ({
    id,
    companyId,
    history,
    unsynchronizeBankAccount
  }) => async params => {
    console.log("(onUnsynchronize)params, id", params, id);

    try {
      await unsynchronizeBankAccount({
        variables: { bankAccountId: params.id },
        refetchQueries: [
          { query: Queries.GET_ALL_BANK_ACCOUNTS, variables: { companyId } },
          { query: Queries.GET_BANK_ACCOUNT, variables: { id } }
        ]
      });
    } catch (e) {
      console.log(e);
    }

    history.push("/payments");
  },

  onCloseAccount: ({
    id,
    companyId,
    history,
    closeBankAccount
  }) => async params => {
    console.log("(onCloseAccount)params, id", params, id);

    try {
      await closeBankAccount({
        variables: { bankAccountId: params.id },
        refetchQueries: [
          { query: Queries.GET_ALL_BANK_ACCOUNTS, variables: { companyId } },
          { query: Queries.GET_BANK_ACCOUNT, variables: { id } },
          { query: Queries.getDashboardInfos, variables: { companyId } }
        ]
      });
    } catch (e) {
      console.log(e);
    }

    sessionStorage.removeItem("paymentListState_bankAccountSelected");
    history.push("/payments");
  },

  onDeleteAccount: ({
    id,
    companyId,
    history,
    closeBankAccount,
    deleteBankAccount
  }) => async params => {
    console.log("(onDeleteAccount)params, id", params, id);

    try {
      await closeBankAccount({
        variables: { bankAccountId: params.id },
        refetchQueries: [
          { query: Queries.GET_ALL_BANK_ACCOUNTS, variables: { companyId } },
          { query: Queries.GET_BANK_ACCOUNT, variables: { id } },
          { query: Queries.getDashboardInfos, variables: { companyId } }
        ]
      });
    } catch (e) {
      console.log(e);
    }

    try {
      deleteBankAccount({
        variables: { bankAccountId: params.id },
        refetchQueries: [
          { query: Queries.GET_ALL_BANK_ACCOUNTS, variables: { companyId } },
          { query: Queries.GET_BANK_ACCOUNT, variables: { id } }
        ]
      });
    } catch (e) {
      console.log(e);
    }

    sessionStorage.removeItem("paymentListState_bankAccountSelected");
    history.push("/payments");
  },

  onMergeAccount: ({
    id,
    companyId,
    history,
    mergeBankAccount
  }) => async params => {
    console.log("(onMergeAccount)params, id", params, id);

    try {
      await mergeBankAccount({
        variables: { bankAccountId: params.id },
        refetchQueries: [
          { query: Queries.GET_ALL_BANK_ACCOUNTS, variables: { companyId } },
          { query: Queries.GET_BANK_ACCOUNT, variables: { id } }
        ]
      });
    } catch (e) {
      console.log(e);
    }

    sessionStorage.removeItem("paymentListState_bankAccountSelected");
    history.push("/payments");
  },

  onRefreshAccount: ({
    id,
    companyId,
    history,
    refreshBankAccount
  }) => async params => {
    console.log("(onRefreshAccount)params, id", params, id);

    try {
      await refreshBankAccount({
        variables: { bankAccountId: params.id },
        refetchQueries: [
          { query: Queries.GET_ALL_BANK_ACCOUNTS, variables: { companyId } },
          { query: Queries.GET_BANK_ACCOUNT, variables: { id } }
        ]
      });
    } catch (e) {
      console.log(e);
    }

    history.push("/payments");
  },

  onImportBankTransactions: ({
    id,
    companyId,
    history,
    importBankTransactions
  }) => async (Params) => {
    console.log("(onImportBankTransactions) Params=", Params, id, companyId);

    let result;
    try {
      result = await importBankTransactions({
        variables: { bankAccountId: id, fileName: Params },
        refetchQueries: [
          { query: Queries.GET_ALL_BANK_ACCOUNTS, variables: { companyId } },
          { query: Queries.GET_BANK_ACCOUNT, variables: { id } }
        ]
      });
    } catch (e) {
      console.log(e);
    }

    history.push("/payments");
    return result;
  }
});

let BankAccountEdit = ({
  getBankAccount,
  updateFormValue,
  onSave,
  onUnsynchronize,
  onCloseAccount,
  onDeleteAccount,
  onMergeAccount,
  onRefreshAccount,
  onImportBankTransactions,
  companyId,
  sendNotification,
  handleMinimizeSidebar
}) => {
  if (getBankAccount.bankAccount) {
    console.log("BankAccountEdit", getBankAccount.bankAccount);

    return (
      <BankAccountForm
        companyId={companyId}
        bankAccountFromQuery={getBankAccount.bankAccount}
        onSave={data => onSave(data)}
        onUnsynchronize={data => onUnsynchronize(data)}
        onCloseAccount={data => onCloseAccount(data)}
        onDeleteAccount={data => onDeleteAccount(data)}
        onMergeAccount={data => onMergeAccount(data)}
        onRefreshAccount={data => onRefreshAccount(data)}
        onImportBankTransactions={data => onImportBankTransactions(data)}
        updateFormValue={updateFormValue}
        sendNotification={sendNotification}
        handleMinimizeSidebar={handleMinimizeSidebar}
      />
    );
  }

  console.log("no bank account");
  return <Spinner size="lg" fullScreen />;
};

export default compose(
  withRouter,
  graphql(Queries.GET_BANK_ACCOUNT, {
    name: "getBankAccount",
    fetchPolicy: "network-only"
    // fetchPolicy: "cache-and-network"
  }),
  graphql(Queries.UPDATE_BANK_ACCOUNT_MUTATION, {
    name: "updateBankAccountMutation"
  }),
  graphql(Queries.unsynchronizeBankAccount, {
    name: "unsynchronizeBankAccount"
  }),
  graphql(Queries.closeBankAccount, {
    name: "closeBankAccount"
  }),
  graphql(Queries.deleteBankAccount, {
    name: "deleteBankAccount"
  }),
  graphql(Queries.mergeBankAccount, {
    name: "mergeBankAccount"
  }),
  graphql(Queries.refreshBankAccount, {
    name: "refreshBankAccount"
  }),
  graphql(Queries.importBankTransactions, {
    name: "importBankTransactions"
  }),
  handlers,
  pure
)(BankAccountEdit);
